import { editPopup } from './editPopup.js'
import { deletePopup } from './localStorage.js'
export const handleClickButtons = (e) => {
  if (e.target.closest('button.edit')) {
    const closestEl = e.target.closest('.person')
    const id = closestEl.dataset.id
    editPopup(id)
  }
  if (e.target.closest('button.delete')) {
    const closestEl = e.target.closest('.person')
    const id = closestEl.dataset.id
    deletePopup(id)
  }
}
